import { useLyftSocket } from '@src/hooks';
import { useAppSelector } from '@store/hooks';
import { selectDriverChat } from '@store/slices/driverChat/driverChatSlice';

type DriverDetails = { phone?: string; image?: string };

export type ResolvedDriver = DriverDetails;

/**
 * The conversation API does not return the driver's phone or photo, so they
 * come from the ride data. Priority: the live ride feed (`socketStatus`, so a
 * number changed on the backend replaces the old one), then what the last
 * "start chat" captured for this segment, then whatever the seed carried.
 */
export const resolveLiveDriver = (
  socketStatus: Record<number, any> | undefined,
  remembered: Record<number, DriverDetails> | undefined,
  segmentId: number,
  fallback: DriverDetails = {}
): ResolvedDriver => {
  const live = socketStatus?.[segmentId]?.fullInfo?.driver;
  const kept = remembered?.[segmentId];
  return {
    phone: live?.phone_number || kept?.phone || fallback.phone,
    image: live?.image_url || kept?.image || fallback.image,
  };
};

export const useLiveDriver = (
  segmentId: number,
  fallback: DriverDetails = {}
): ResolvedDriver => {
  const { socketStatus } = useLyftSocket();
  const { drivers } = useAppSelector(selectDriverChat);
  return resolveLiveDriver(socketStatus, drivers, segmentId, fallback);
};
